/**
 * Column of entity
 */
export class EntityColumn {
  /**
   * @param {Object} Column
   * @param {String} Column.name Name of the Column
   * @param {String} Column.id Id of the Column
   */
  constructor({ id, name, datasource_id }) {
    this.id = id;
    // if name is not present, split the id from the entity name and get the name
    // usually the id is the format > "raw_datasourceid__columnname"
    this.name = name || id.split("__")[1] || id;
    this.datasource_id = datasource_id;
  }
}

/**
 * MetaData of the entity
 */
export class EntityMeta {
  /**
   * @param {Object} MetaData
   * @param {Array} MetaData.events List of all the events present in the entity
   * @param {Object} MetaData.lookup_view Data related to the lookup
   * @param {String} MetaData.join_entity Entity to which the join is present
   * @param {String} MetaData.join_col Column id of the joinable entity
   */
  constructor({
    events = null,
    lookup_view = null,
    join_entity = null,
    join_col = null,
  }) {
    this.events = events;
    this.lookup_view = lookup_view;
    this.join_entity = join_entity;
    this.join_col = join_col;
  }
}

export default class Entity {
  /**
   *
   * @param {Object} param0
   * @param {String} param0.id Id of the Entity
   * @param {String} param0.name Name of the Entity
   * @param {String} param0.description Description of the Entity
   * @param {String} param0.geo_col Location column of the Entity
   * @param {String} param0.time_col Time Column of the Entity
   * @param {String} param0.created_by Name of the user who created the entity
   * @param {String} param0.created_at Date and time of the entity created
   * @param {Array[Object]} param0.datasources Object containing the details of the datasources of the entity
   * @param {String} param0.entity_type Type of the entity
   * @param {Object} param0.meta MetaData related to the enity, might contain the columns describing events and loookup
   */
  constructor({
    id,
    name,
    description,
    geo_col,
    time_col,
    created_by,
    created_at,
    datasources,
    entity_type,
    category,
    meta,
  }) {
    this.id = id;
    this.entity_id = id;
    this.name = name;
    this.entity_name = name;
    this.entity_type = entity_type;
    this.description = description;
    this.geo_col = geo_col;
    this.time_col = time_col;
    this.created_by = created_by;
    this.created_at = created_at;
    this.selected_columns = [];
    this.entity_id_col = "";
    this.category = category;
    this.datasources = Object.keys(datasources).map(datasource_id => {
      const datasource = datasources[datasource_id];
      // get columns from all datasources associated with it
      datasource.selected_cols.forEach(column => {
        this.selected_columns.push(
          new EntityColumn({ name: column, id: column, datasource_id })
        );
      });
      // find the entity id column from the base data source
      if (datasource.type === "base") {
        this.entity_id_col = datasource.entity_id_col;
      }
      return {
        ...datasource,
        datasource_id,
      };
    });
    if (meta) this.meta = new EntityMeta(meta);
  }

  getBaseDatasource() {
    return this.datasources.find(ds => ds.type === "base");
  }
}
